import {
  buildStyleFromLiteral,
} from '../tools/services/styles-literal'

export default function (options) {
  return buildStyleFromLiteral(options)
}
